
class ModalVideo extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Handles the initialization of a price range custom element and its associated functionality.
   *
   * @function
   */
  connectedCallback() {
    const openModal = document.querySelectorAll('.see-in-action');

    openModal.forEach(element => {

      element.addEventListener('click', this.openModal.bind(this))
      this.querySelector('.icon-close').addEventListener('click', this.closeModal.bind(this))
    })
  }

  closeModal(e) {
    const modal = e.target.closest('.modal-video-js');
    modal.classList.remove('active-modal');
  }

  openModal(e){
    const modal = document.querySelector('.modal-video-js');
    modal.classList.add('active-modal')
  }

}

customElements.define('modal-video', ModalVideo);
